import ObjectUtils, { coalesce } from "../../../../../utils/ObjectUtils";
import { findAnswer, makeAnswer } from "../../../../../utils/QuestionUtils";

import PropTypes from "prop-types";
import React from "react";
import RichTextEditor from "../../../../common/richTextEditor/RichTextEditor";
import { LENGTH_TYPE } from "../../../../../utils/ValidatorUtils";

const { getDeepProperty } = ObjectUtils;

/**
 * Text question component for survey-view.
 */
const RichTextRenderer = ({
  disabled,
  question,
  collection,
  setQuestionAnswer,
  row,
  column,
  isIncomplete
}) => {
  const answer = findAnswer(collection, { row, column });
  const textValue = coalesce(getDeepProperty(answer, "value"), "");
  const lengthValidator = coalesce(getDeepProperty(question, "validators"), []).find(
    (validator) =>
      validator.validatorType === LENGTH_TYPE &&
      (!column || !validator.columnName || validator.columnName === column.name)
  );
  const configuredMaxLength = getDeepProperty(lengthValidator, "props", "length");
  const hasConfiguredMaxLength =
    configuredMaxLength !== null &&
    configuredMaxLength !== undefined &&
    String(configuredMaxLength).trim() !== "";
  const numericMaxLength = Number(configuredMaxLength);
  const maxLength =
    hasConfiguredMaxLength && Number.isFinite(numericMaxLength) && numericMaxLength >= 0
      ? numericMaxLength
      : undefined;

  const handleChange = (text, validateOnly) => {
    setQuestionAnswer(question, makeAnswer(text, row, column), validateOnly);
  };

  return (
    <RichTextEditor
      disabled={disabled}
      onTextChange={handleChange}
      htmlContent={textValue}
      isIncomplete={isIncomplete}
      maxLength={maxLength}
    />
  );
};

RichTextRenderer.propTypes = {
  disabled: PropTypes.bool,
  question: PropTypes.object.isRequired,
  collection: PropTypes.array,
  setQuestionAnswer: PropTypes.func.isRequired,
  row: PropTypes.object,
  column: PropTypes.object,
  isIncomplete: PropTypes.bool,
};

export default React.memo(RichTextRenderer);
